import Menu from '@mui/material/Menu';
import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';

interface OptionData {
    Name?: string;
    Icon: any;
    OnClick: (e?: any) => void;
    Hide?: boolean;
}

interface Props {
    MenuData?: OptionData[];
    MeetBallIcon?: any
    HorizantelIcon?: boolean;
    ClassName?: any;
    Data?: any;
}

export const MenuItemRender = (props: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const MeetBallIcon = props.MeetBallIcon

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: any) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    return (
        <>
            <span onClick={handleClick} className={`${props.ClassName ? props.ClassName : ""} c-pointer`}>
                {!!props.MeetBallIcon && <MeetBallIcon />}
            </span>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={(e) => handleClose(e)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    className: "bg-color-sidebar-bg",
                }}
            >
                {props.MenuData.map((option: OptionData, index: number) => {
                    const Icon = option.Icon;
                    return !option.Hide &&
                        <MenuItem onClick={(e) => { option?.OnClick(e); handleClose(e) }} key={`${option.Name}-${index}`}>
                            {option?.Icon && <Icon className="mr-1 w-2" />}
                            <span className={"h4-regular color-menu-list-font-color"}>{option.Name}</span>
                        </MenuItem>
                }
                )}
            </Menu>

        </>)
};
